import { Constants } from './'

const initialState = {
  isLoading: true,
  isLoadingProducts: true,
  hasError: false,
  hasHighlightedFilters: false,
  products: [],
  pageInfo: {},
  filters: [],
  sorters: [],
  metadata: {},
  metaTags: {},
  query: {},
  baseUrl: null,
  searchType: null,
  isMobileFilterActive: false,
  isInitialRender: true
}

export const initializeState = ({ propSearchType, url }) => {
  return {
    ...initialState,
    searchType: propSearchType,
    baseUrl: url
  }
}

export const reducer = (state, action) => {
  switch (action.type) {
    case Constants.UPDATE_QUERY: {
      const { newQuery, loadOnlyProducts } = action.payload

      return {
        ...state,
        isLoading: !loadOnlyProducts,
        isLoadingProducts: loadOnlyProducts,
        query: newQuery,
        isInitialRender: false
      }
    }

    case Constants.TOGGLE_MOBILE_FILTER: {
      return {
        ...state,
        isMobileFilterActive: !state.isMobileFilterActive
      }
    }

    case Constants.GET_PRODUCTS_SUCCESS: {
      const {
        products,
        name,
        filters,
        sorters,
        topDescription: description,
        descriptiveText,
        video,
        contents,
        metadata,
        metaTags,
        searchType,
        term,
        filterTitle
      } = action.payload.data

      return {
        ...state,
        isLoading: false,
        isLoadingProducts: false,
        filters,
        sorters,
        products,
        metadata,
        metaTags,
        pageInfo: {
          name: (action.payload.isSearch ? term : name) || 'resultados',
          description,
          video,
          contents,
          descriptiveText,
          filterTitle
        },
        searchType,
        hasHighlightedFilters: filters.some(filter => filter.highlight)
      }
    }

    case Constants.GET_PRODCUTS_FAILURE: {
      return {
        ...state,
        isLoading: false,
        hasError: true,
        products: []
      }
    }

    default: {
      return state
    }
  }
}
